var map = {
	"./XrayIcon.png": 44,
	"./bee.png": 45,
	"./bg2.png": 46,
	"./colored-pencils.jpg": 47,
	"./colored-wood.jpg": 48,
	"./finallogo.png": 25,
	"./icon-dental-braces.png": 49,
	"./icon-kid.png": 50,
	"./icon-pa.png": 51,
	"./icons-dental-filling.png": 52,
	"./icons-dental-machine.png": 53,
	"./icons-dental-mirror.png": 54,
	"./icons-tooth-cracked.png": 55,
	"./jim-cartoon.png": 56,
	"./jim-crayon.png": 57,
	"./jim.png": 58,
	"./lamb.png": 59,
	"./teeth-header.png": 60,
	"./tim-cartoon.png": 61,
	"./tim-crayon.png": 62,
	"./tim.png": 63,
	"./wood.jpg": 64,
	"./wood2.png": 65,
	"./wood3.png": 66,
	"./wood4.jpg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;